import {AuthProvider} from 'contexts/authContext'
import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter as Router} from 'react-router-dom'

import App from './App'

import './index.css'

const Root = (
  <Router>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Router>
)

ReactDOM.render(Root, document.getElementById('root'))
